module.exports = __webpack_public_path__ + "img/prev.cca96fba.svg";